import { useQuery } from "@tanstack/react-query"
import { customerIssuesQuery } from "../lib/customerIssuesQuery"

export function useCustomerIssuesQuery(...args: Parameters<typeof customerIssuesQuery>) {
  return useQuery(customerIssuesQuery(...args))
}
